import React from 'react';
import { 
    FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, 
    FaEnvelope, FaLink, FaSpotify, FaSoundcloud, FaTiktok, 
    FaGithub, FaPinterest, FaDiscord, FaTwitch, FaWhatsapp, 
    FaTelegram, FaReddit 
} from 'react-icons/fa';
import { SiThreads } from 'react-icons/si';

export const getSocialIcon = (platform, size = 18) => {
    const p = (platform || '').toLowerCase();
    switch (p) {
        case 'facebook': return <FaFacebook size={size} />;
        case 'twitter':
        case 'x': return <FaTwitter size={size} />;
        case 'instagram': return <FaInstagram size={size} />;
        case 'linkedin': return <FaLinkedin size={size} />;
        case 'youtube': return <FaYoutube size={size} />;
        case 'email': return <FaEnvelope size={size} />;
        case 'spotify': return <FaSpotify size={size} />;
        case 'soundcloud': return <FaSoundcloud size={size} />;
        case 'tiktok': return <FaTiktok size={size} />;
        case 'github': return <FaGithub size={size} />;
        case 'pinterest': return <FaPinterest size={size} />;
        case 'discord': return <FaDiscord size={size} />;
        case 'twitch': return <FaTwitch size={size} />;
        case 'whatsapp': return <FaWhatsapp size={size} />;
        case 'telegram': return <FaTelegram size={size} />;
        case 'threads': return <SiThreads size={size} />;
        case 'reddit': return <FaReddit size={size} />;
        default: return <FaLink size={size} />;
    }
};

export default getSocialIcon;
